/**
 * MerlinIframe — embeds the production Merlin intake surface served from
 * merlin.artificersai.com. Used by IntakePage (/intake) as a full-bleed embed.
 * Only the intake variant is supported; it maps to /intake. The merlin server sets
 * `Content-Security-Policy: frame-ancestors 'self' https://artificersai.com
 * https://*.artificersai.com` on its HTML responses so this iframe loads
 * without browser blocks.
 *
 * Override the host with VITE_MERLIN_BASE_URL when running against a local
 * Merlin dev server (e.g. http://localhost:5173).
 */
import { useMemo } from 'react';

const DEFAULT_BASE = 'https://merlin.artificersai.com';

const VARIANT_PATH = {
  intake: '/intake',
};

export default function MerlinIframe({ variant, title, height = '100vh' }) {
  const src = useMemo(() => {
    const base = (
      import.meta.env.VITE_MERLIN_BASE_URL ?? DEFAULT_BASE
    ).replace(/\/$/, '');
    const path = VARIANT_PATH[variant] ?? '/intake';
    return `${base}${path}`;
  }, [variant]);

  return (
    <iframe
      title={title ?? `Merlin ${variant}`}
      src={src}
      allow="microphone; autoplay"
      className="merlin-iframe"
      style={{
        width: '100%',
        height,
        border: 0,
        display: 'block',
      }}
    />
  );
}
